import React, { useState } from 'react';
import Logos from './Logos';
import Review from './Review';
import { useNavigate } from 'react-router-dom';
import Footer from './Footer';

const PlaceOrderButton = () => {
  const BASE_URL = 'https://node.insuranceadvisors.pk';

  const [travellerName, setTravellerName] = useState('');
  const [policyType, setPolicyType] = useState('');
  const [travelStartDate, setTravelStartDate] = useState('');
  const [country, setCountry] = useState('');
  const [duration, setDuration] = useState('');
  const [contact, setContact] = useState('');
  const [email, setEmail] = useState('');
  
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();

    const orderData = { travellerName, policyType, travelStartDate, country, duration, email, contact };

    try {
      // Save order data to the backend
      const saveResponse = await fetch(`${BASE_URL}/api/travel/submit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(orderData),
      });

      if (saveResponse.ok) {
        // Email sending logic (assuming email is part of the response)
        const emailResponse = await fetch(`${BASE_URL}/api/sendTravelEmail`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(orderData),
        });

        if (emailResponse.ok) {
          // Alert and navigation inside the success condition
          alert('Order placed and email sent successfully!');
          navigate('/our'); // Redirect to a confirmation page or desired page using useNavigate
        } else {
          // Log the response to debug if email is not being sent
          const emailError = await emailResponse.text();
          console.error('Failed to send email:', emailError);
          alert('Failed to send email. Please try again later.');
        }
      } else {
        // Log the response to debug if saving the order fails
        const saveError = await saveResponse.text();
        console.error('Failed to submit data:', saveError);
        alert('Failed to submit order. Please try again later.');
      }
    } catch (error) {
      console.error('Error submitting data:', error);
      alert('An error occurred. Please try again later.');
    }
  };

  return (
    <div>
     <div className="container-fluid trvl" style={{ marginBottom: '0', paddingBottom: '0' }}>
  <h5>
    <marquee>LIMITED TIME OFFER...Offering upto 15% discount on Travel Insurance.</marquee>
  </h5>
</div>


      <div className="container col-sm-12">
        <div className="row">

        <div className="col-12 col-sm-6 mb-3 mb-sm-0 px-0 px-sm-3 mt-0" style={{ marginTop: '-10px', paddingTop: '-10px' }}>
  <img src="./assets/img/travelimg.png" className="img-fluid" id='hu2' alt="Travel Insurance" style={{ height: '570px', width: '100%' }} />
</div>


      


          <div className="col-sm-6 mb-3 mb-sm-0" id="d1">
            <h3 className='cl32'>Enter Your Details</h3>
            <form onSubmit={handleSubmit}>
              {/* Name Field */}
              <input
                className="form-control form-control-md"
                name="travellerName"
                placeholder="Enter Your Name"
                required
                value={travellerName}
                onChange={(e) => setTravellerName(e.target.value)}
              />
              <br />

              {/* Policy Type Dropdown */}
              <select
                className="form-control form-control-md"
                name="policyType"
                required
                value={policyType}
                onChange={(e) => setPolicyType(e.target.value)}
              >
                <option value="">Select Policy Type</option>
                <option value="Individual">Individual</option>
                <option value="Family">Family</option>
              </select>
              <br />
<input
  type="date"
  className="form-control form-control-md"
  name="travelStartDate"
  required
  value={travelStartDate}
  onChange={(e) => setTravelStartDate(e.target.value)}
  min={new Date().toISOString().split('T')[0]} // Set today's date as the minimum allowed date
/>
<br/>

              {/* Country to Travel Dropdown */}
        <select
          className="form-control form-control-md"
          name="country"
          required
         value={country}
         onChange={(e) => setCountry(e.target.value)}
        >
         <option value="">Select Country</option>
          <option value="Afghanistan">Afghanistan</option>
          <option value="Albania">Albania</option>
          <option value="Algeria">Algeria</option>
          <option value="Andorra">Andorra</option>
          <option value="Angola">Angola</option>
          <option value="Antigua and Barbuda">Antigua and Barbuda</option>
          <option value="Argentina">Argentina</option>
          <option value="Armenia">Armenia</option>
          <option value="Australia">Australia</option>
          <option value="Austria">Austria</option>
          <option value="Azerbaijan">Azerbaijan</option>
          <option value="Bahamas">Bahamas</option>
          <option value="Bahrain">Bahrain</option>
          <option value="Bangladesh">Bangladesh</option>
          <option value="Barbados">Barbados</option>
          <option value="Belarus">Belarus</option>
          <option value="Belgium">Belgium</option>
          <option value="Belize">Belize</option>
          <option value="Benin">Benin</option>
          <option value="Bhutan">Bhutan</option>
          <option value="Bolivia">Bolivia</option>
          <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
          <option value="Botswana">Botswana</option>
          <option value="Brazil">Brazil</option>
          <option value="Brunei">Brunei</option>
          <option value="Bulgaria">Bulgaria</option>
          <option value="Burkina Faso">Burkina Faso</option>
          <option value="Burundi">Burundi</option>
          <option value="Cabo Verde">Cabo Verde</option>
          <option value="Cambodia">Cambodia</option>
          <option value="Cameroon">Cameroon</option>
          <option value="Canada">Canada</option>
          <option value="Central African Republic">Central African Republic</option>
          <option value="Chad">Chad</option>
          <option value="Chile">Chile</option>
          <option value="China">China</option>
          <option value="Colombia">Colombia</option>
          <option value="Comoros">Comoros</option>
          <option value="Congo, Democratic Republic of the">Congo, Democratic Republic of the</option>
          <option value="Congo, Republic of the">Congo, Republic of the</option>
          <option value="Costa Rica">Costa Rica</option>
          <option value="Croatia">Croatia</option>
          <option value="Cuba">Cuba</option>
          <option value="Cyprus">Cyprus</option>
          <option value="Czech Republic">Czech Republic</option>
          <option value="Denmark">Denmark</option>
          <option value="Djibouti">Djibouti</option>
          <option value="Dominica">Dominica</option>
          <option value="Dominican Republic">Dominican Republic</option>
          <option value="Ecuador">Ecuador</option>
          <option value="Egypt">Egypt</option>
          <option value="El Salvador">El Salvador</option>
          <option value="Equatorial Guinea">Equatorial Guinea</option>
          <option value="Eritrea">Eritrea</option>
          <option value="Estonia">Estonia</option>
          <option value="Eswatini">Eswatini</option>
          <option value="Ethiopia">Ethiopia</option>
          <option value="Fiji">Fiji</option>
          <option value="Finland">Finland</option>
          <option value="France">France</option>
          <option value="Gabon">Gabon</option>
          <option value="Gambia">Gambia</option>
          <option value="Georgia">Georgia</option>
          <option value="Germany">Germany</option>
          <option value="Ghana">Ghana</option>
          <option value="Greece">Greece</option>
          <option value="Grenada">Grenada</option>
          <option value="Guatemala">Guatemala</option>
          <option value="Guinea">Guinea</option>
          <option value="Guinea-Bissau">Guinea-Bissau</option>
          <option value="Guyana">Guyana</option>
          <option value="Haiti">Haiti</option>
          <option value="Honduras">Honduras</option>
          <option value="Hungary">Hungary</option>
          <option value="Iceland">Iceland</option>
          <option value="India">India</option>
          <option value="Indonesia">Indonesia</option>
          <option value="Iran">Iran</option>
          <option value="Iraq">Iraq</option>
          <option value="Ireland">Ireland</option>
          <option value="Israel">Israel</option>
          <option value="Italy">Italy</option>
          <option value="Jamaica">Jamaica</option>
          <option value="Japan">Japan</option>
          <option value="Jordan">Jordan</option>
          <option value="Kazakhstan">Kazakhstan</option>
          <option value="Kenya">Kenya</option>
          <option value="Kiribati">Kiribati</option>
          <option value="Korea, North">Korea, North</option>
          <option value="Korea, South">Korea, South</option>
          <option value="Kosovo">Kosovo</option>
          <option value="Kuwait">Kuwait</option>
          <option value="Kyrgyzstan">Kyrgyzstan</option>
          <option value="Laos">Laos</option>
          <option value="Latvia">Latvia</option>
          <option value="Lebanon">Lebanon</option>
          <option value="Lesotho">Lesotho</option>
          <option value="Liberia">Liberia</option>
          <option value="Libya">Libya</option>
          <option value="Liechtenstein">Liechtenstein</option>
          <option value="Lithuania">Lithuania</option>
          <option value="Luxembourg">Luxembourg</option>
          <option value="Madagascar">Madagascar</option>
          <option value="Malawi">Malawi</option>
          <option value="Malaysia">Malaysia</option>
          <option value="Maldives">Maldives</option>
          <option value="Mali">Mali</option>
          <option value="Malta">Malta</option>
          <option value="Marshall Islands">Marshall Islands</option>
          <option value="Mauritania">Mauritania</option>
          <option value="Mauritius">Mauritius</option>
          <option value="Mexico">Mexico</option>
          <option value="Micronesia">Micronesia</option>
          <option value="Moldova">Moldova</option>
          <option value="Monaco">Monaco</option>
          <option value="Mongolia">Mongolia</option>
          <option value="Montenegro">Montenegro</option>
          <option value="Morocco">Morocco</option>
          <option value="Mozambique">Mozambique</option>
          <option value="Myanmar">Myanmar</option>
          <option value="Namibia">Namibia</option>
          <option value="Nauru">Nauru</option>
          <option value="Nepal">Nepal</option>
          <option value="Netherlands">Netherlands</option>
          <option value="New Zealand">New Zealand</option>
          <option value="Nicaragua">Nicaragua</option>
          <option value="Niger">Niger</option>
          <option value="Nigeria">Nigeria</option>
          <option value="North Macedonia">North Macedonia</option>
          <option value="Norway">Norway</option>
          <option value="Oman">Oman</option>
          <option value="Pakistan">Pakistan</option>
          <option value="Palau">Palau</option>
          <option value="Panama">Panama</option>
          <option value="Papua New Guinea">Papua New Guinea</option>
          <option value="Paraguay">Paraguay</option>
          <option value="Peru">Peru</option>
          <option value="Philippines">Philippines</option>
          <option value="Poland">Poland</option>
          <option value="Portugal">Portugal</option>
          <option value="Qatar">Qatar</option>
          <option value="Romania">Romania</option>
          <option value="Russia">Russia</option>
          <option value="Rwanda">Rwanda</option>
          <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
          <option value="Saint Lucia">Saint Lucia</option>
          <option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
          <option value="Samoa">Samoa</option>
          <option value="San Marino">San Marino</option>
          <option value="Sao Tome and Principe">Sao Tome and Principe</option>
          <option value="Saudi Arabia">Saudi Arabia</option>
          <option value="Senegal">Senegal</option>
          <option value="Serbia">Serbia</option>
          <option value="Seychelles">Seychelles</option>
          <option value="Sierra Leone">Sierra Leone</option>
          <option value="Singapore">Singapore</option>
          <option value="Slovakia">Slovakia</option>
          <option value="Slovenia">Slovenia</option>
          <option value="Solomon Islands">Solomon Islands</option>
          <option value="Somalia">Somalia</option>
          <option value="South Africa">South Africa</option>
          <option value="South Sudan">South Sudan</option>
          <option value="Spain">Spain</option>
          <option value="Sri Lanka">Sri Lanka</option>
          <option value="Sudan">Sudan</option>
          <option value="Suriname">Suriname</option>
          <option value="Sweden">Sweden</option>
          <option value="Switzerland">Switzerland</option>
          <option value="Syria">Syria</option>
          <option value="Taiwan">Taiwan</option>
          <option value="Tajikistan">Tajikistan</option>
          <option value="Tanzania">Tanzania</option>
          <option value="Thailand">Thailand</option>
          <option value="Timor-Leste">Timor-Leste</option>
          <option value="Togo">Togo</option>
          <option value="Tonga">Tonga</option>
          <option value="Trinidad and Tobago">Trinidad and Tobago</option>
          <option value="Tunisia">Tunisia</option>
          <option value="Turkey">Turkey</option>
          <option value="Turkmenistan">Turkmenistan</option>
          <option value="Tuvalu">Tuvalu</option>
          <option value="Uganda">Uganda</option>
          <option value="Ukraine">Ukraine</option>
          <option value="United Arab Emirates">United Arab Emirates</option>
          <option value="United Kingdom">United Kingdom</option>
          <option value="United States">United States</option>
          <option value="Uruguay">Uruguay</option>
          <option value="Uzbekistan">Uzbekistan</option>
          <option value="Vanuatu">Vanuatu</option>
          <option value="Venezuela">Venezuela</option>
          <option value="Vietnam">Vietnam</option>
          <option value="Yemen">Yemen</option>
          <option value="Zambia">Zambia</option>
          <option value="Zimbabwe">Zimbabwe</option>
          {/* Include a list of all countries as needed */}
        </select>
        <br />

             {/* Duration Dropdown */}
        <select
          className="form-control form-control-md"
          name="duration"
          required
          value={duration}
          onChange={(e) => setDuration(e.target.value)}
        >
          <option value="">Select Duration</option>
          <option value="7 Days">7 Days</option>
          <option value="15 Days">15 Days</option>
          <option value="31 Days">31 Days</option>
          <option value="62 Days">62 Days</option>
          <option value="92 Days">92 Days</option>
          <option value="180 Days">180 Days</option>
          <option value="365 Days">365 Days</option>
          <option value="2 Years">2 Years</option>



          {/* Add more options if needed */}
        </select>
        <br />

              {/* Contact Field */}
              <input
                className="form-control form-control-md"
                name="contact"
                placeholder="Enter Your Contact Number"
                required
                value={contact}
                onChange={(e) => setContact(e.target.value)}
              />
              <br />

              {/* Email Field */}
              <input
                type="email"
                className="form-control form-control-md"
                name="email"
                placeholder="Enter Your Email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <br />

              {/* Submit Button */}
              <div id="mid">
              <button type="submit" className="btn btn-danger btn-lg" >Place Order</button></div>
              <br></br>
            </form>
          </div>
        </div>
      </div>

      <div>
        <Logos />
      </div>
      <br/><br/><br/><br/>
      <div>
        <Review />
      </div>
      <br/>
<div id="ss">
      <div class="insurance-wrapper">
    <h2>TYPES OF TRAVEL INSURANCE</h2>
    <p class="subheading">Explore the world with confidence. Our range of travel insurance policies ensures your journey is safe, secure, and worry-free.</p>
    
    <div class="cards-wrapper">
        <div class="insurance-card">
            <div class="card-icon"><i class="fas fa-plane"></i></div>
            <h3>Trip Cancellation Coverage</h3>
            <p>"Travel worry-free with our Trip Cancellation Coverage. Protect your investment against unexpected cancellations, delays, or disruptions. Your dream trip remains stress-free and secure no matter what comes your way."</p>
        </div>
        <div class="insurance-card">
            <div class="card-icon"><i class="fas fa-first-aid"></i></div>
            <h3>Medical Emergency Insurance</h3>
            <p>"Stay prepared for the unexpected with our Medical Emergency Insurance. Covering medical costs and emergencies abroad, this policy ensures you receive the best care wherever you travel. Travel safe, stay secure."</p>
        </div>
        <div class="insurance-card">
            <div class="card-icon"><i class="fas fa-briefcase"></i></div>
            <h3>Baggage and Personal Items</h3>
            <p>"Protect your belongings with our Baggage and Personal Items Insurance. Covering lost, stolen, or damaged items, our policy ensures your possessions are as secure as your travel plans."</p>
        </div>
    </div>
</div>
</div>
<br></br>
<Footer></Footer>



    </div>
  );
};

export default PlaceOrderButton;
